'use client';

import React, { useMemo } from 'react';

import { Article, SNIPPET_TYPE } from '@repo/types';

import { Charts } from './main-charts/charts';

interface MainChartsProps {
  currTab: SNIPPET_TYPE;
  setCurrTab: (tab: SNIPPET_TYPE) => void;
  articleMetrics?: Article;
}

export const PureMainCharts: React.FC<MainChartsProps> = ({
  currTab,
  setCurrTab,
  articleMetrics,
}) => {
  const metrics = useMemo(
    () => articleMetrics?.metrics || undefined,
    [articleMetrics?.metrics],
  );

  // Analytics wire id: the SLUG (matches analysis_opened.article_id on web);
  // numeric backend id only as a fallback for un-slugged payloads.
  const articleId =
    articleMetrics?.slug ??
    (articleMetrics ? String(articleMetrics.id) : undefined);

  return (
    <Charts
      metrics={metrics}
      currTab={currTab}
      setCurrTab={setCurrTab}
      articleId={articleId}
    />
  );
};
